<template lang="pug" src="./createAccount.pug"> </template>
<style lang="scss" src="./createAccount.scss" scoped> </style>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength, requiredIf } from 'vuelidate/lib/validators'
import validate from '@/mixins/validate'
import { mapState } from 'vuex'

export default {
    mixins: [validationMixin, validate],
    data: () => ({
        password: '',
        confirmPassword: '',
        roleId: null,
        includeTelephony: false
    }),
    validations: {
        email: {
            required,
            email
        },
        password: {
            required,
            minLength: minLength(6)
        },
        confirmPassword: {
            required,
            equal: function() {
                return this.password == this.confirmPassword
            }
        },
        roleId: {
            required: requiredIf(function() {
                return this.type === 'admin'
            })
        },
        activeLeader: {
            required: requiredIf(function() {
                return this.type === 'business'
            })
        }
    },
    computed: {
        ...mapState({
            email: state => state.createAccount.email,
            type: state => state.createAccount.type,
            leaders: state => state.data.leaders,
            activeLeader: state => state.createAccount.activeLeader,
            rolesList: state => state.roles.rolesList
        }),
        typeSelects: function() {
            const typeSelects = '$vuetify.pages.CreateAccounts.selects'
            return ['admin', 'leader', 'business'].map(it => ({
                text: this.$vuetify.t(`${typeSelects}.${it}`),
                value: it
            }))
        }
    },
    async created() {
        await this.$store.dispatch('roles/getRolesList')
    },
    methods: {
        createAccount() {
            if (this.$v.$invalid) {
                this.$v.$touch()
            } else {
                const payload = {
                    email: this.email,
                    password: this.password,
                    confirmPassword: this.confirmPassword,
                    type: this.type,
                    leaderId: this.activeLeader && this.activeLeader.id,
                    text: this.$vuetify.t(`$vuetify.pages.ConfirmAccount.text`),
                    subject: this.$vuetify.t(`$vuetify.pages.ConfirmAccount.subject`),
                    roleId: this.roleId
                }

                if (this.type === 'leader') {
                    Object.assign(payload, { includeTelephony: this.includeTelephony })
                }

                this.$store.dispatch('createAccount/createAccount', payload)

                this.resetCreateAccount()
            }
        },

        onTypeSelect(type) {
            this.$store.commit('createAccount/SET_ACTIVE_TYPE', type)
            if (type === 'business') {
                this.$store.dispatch('getLeaders')
            }
        },

        onRoleChange(roleId) {
            this.roleId = roleId
        },

        onLeaderSelect(leader) {
            this.$store.commit('createAccount/SET_ACTIVE_LEADER', leader)
        },

        onEmailChange(email) {
            this.$store.commit('createAccount/SET_EMAIL', email)
        },

        resetCreateAccount() {
            this.password = ''
            this.confirmPassword = ''
            this.roleId = null
            this.includeTelephony = false

            this.$nextTick(_ => {
                this.$v.$reset()
            })

            this.$store.commit('createAccount/RESET_CREATE_ACCOUNT')
        }
    }
}
</script>
